import { useQuery } from '@tanstack/react-query';
import { fetchFolderContent } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useFetchFolderContent = (folderId: string) =>
  useQuery({
    queryFn: () =>
      extractData(
        fetchFolderContent({
          path: { folderId },
        })
      ),
    queryKey: ['document-share', 'folders', folderId],
  });
